import request from '@/utils/request'

export function login (data) {
  return request({
    url: '/auth',
    method: 'post',
    data
  })
}

export function logout (token) {
  return request({
    url: '/api/v1/logout',
    method: 'post',
    headers: {
      'x-qinglee-auth': token
    },
    timeout: 5000,
    skipAuthFailureHandling: true
  })
}

export function getUserList (params) {
  return request({
    url: '/api/v1/users',
    method: 'get',
    params
  })
}

export function addUser (data) {
  return request({
    url: '/api/v1/users',
    method: 'post',
    data
  })
}

export function getUserInfo (id) {
  return request({
    url: '/api/v1/users/' + id,
    method: 'get'
  })
}

export function updateUserInfo (id, data) {
  return request({
    url: '/api/v1/users/' + id,
    method: 'put',
    data
  })
}

export function getUserRoleAssignmentOptions (params) {
  return request({ url: '/api/v1/user-role-assignment-options', method: 'get', params })
}

export function updatePassword (data) {
  return request({
    url: '/api/v1/password',
    method: 'put',
    data
  })
}

export function resetUserPassword (id, data) {
  return request({
    url: `/api/v1/users/${id}/password`,
    method: 'put',
    data
  })
}

export function sendSMSCode (data) {
  return request({
    url: '/sms-code',
    businessErrorDetails: true,
    method: 'post',
    data
  })
}

export function loginSMS (data) {
  return request({
    url: '/sms-auth',
    method: 'post',
    data
  })
}

export function getLoginHistory () {
  return request({
    url: '/api/v1/login-info',
    method: 'get'
  })
}

export function getMyProfile () {
  return request({ url: '/api/v2/me/profile', method: 'get' })
}

export function updateMyProfile (data) {
  return request({ url: '/api/v2/me/profile', method: 'put', data })
}

export function getMyLoginHistory (params) {
  return request({ url: '/api/v2/me/login-info', method: 'get', params })
}

export function getUserLoginHistory (id, params) {
  return request({ url: `/api/v1/users/${id}/login-info`, method: 'get', params })
}

export function getMyAvatarUploadCredential () {
  return request({ url: '/api/v2/me/avatar-upload-credential', method: 'get' })
}

export function updateMyAvatar (url) {
  return request({ url: '/api/v2/me/avatar', method: 'put', data: { url } })
}

export function loginMFA (data) {
  return request({ url: '/mfa-auth', method: 'post', data, businessErrorDetails: true })
}

export function getMyMFA () {
  return request({ url: '/api/v2/me/mfa', method: 'get' })
}

export function startMyMFAChange (data) {
  return request({ url: '/api/v2/me/mfa/challenge', method: 'post', data, businessErrorDetails: true })
}

export function sendMyMFASMS (data) {
  return request({ url: '/api/v2/me/mfa/sms', method: 'post', data, businessErrorDetails: true })
}

export function verifyMyMFAChange (data) {
  return request({ url: '/api/v2/me/mfa/verify', method: 'post', data, businessErrorDetails: true })
}



// WEBPACK FOOTER //
// ./src/api/user.js